import { BaseModalProps, Modal } from '@/components/Modal';
import { Contract } from '@console/utils';
import { useTranslation } from 'react-i18next';
import { ContractForm, ContractFormData } from './ContractForm';
import { UpdateContractDto } from '@/lib/api/contracts';

export interface UpdateContractModalProps extends BaseModalProps {
  contract: Contract;
  onUpdate: (id: string, data: UpdateContractDto) => Promise<boolean>;
  isUpdating: boolean;
}

export function UpdateContractModal({
  open,
  onOpenChange,
  contract,
  onUpdate,
  isUpdating,
}: UpdateContractModalProps) {
  const { t } = useTranslation();

  const handleSubmit = async (data: ContractFormData) => {
    const success = await onUpdate(contract.id, {
      companyName: data.companyName,
      contractNumber: data.contractNumber,
      startDate: data.startDate,
      endDate: data.endDate,
      contractedHours: data.contractedHours,
      monthlyHoursLimit: data.monthlyHoursLimit,
      minDebitTime: data.minDebitTime,
      accumulateHours: data.accumulateHours,
      excludeProactiveTickets: data.excludeProactiveTickets,
      archived: data.archived,
    });

    if (success) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={t('contracts.updateModal.title')}>
      <ContractForm
        mode="update"
        onSubmit={handleSubmit}
        isLoading={isUpdating}
        initialData={{
          companyName: contract.company.name,
          contractNumber: contract.number,
          startDate: contract.startDate ? new Date(contract.startDate) : undefined,
          endDate: contract.endDate ? new Date(contract.endDate) : undefined,
          contractedHours: contract.contractedHours.toString(),
          monthlyHoursLimit: contract.monthlyHoursLimit?.toString(),
          minDebitTime: contract.minDebitTime.toString(),
          accumulateHours: contract.accumulateHours,
          excludeProactiveTickets: contract.excludeProactiveTickets,
          archived: !!contract.archivedAt,
        }}
        onCancel={handleCancel}
      />
    </Modal>
  );
}
